import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ThemeService } from './core/services/theme.service';
import { forceResetLoader } from './core/interceptors/loading.interceptor';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxSpinnerModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('eventz-ui');

  constructor(
    private themeService: ThemeService,
    private spinner: NgxSpinnerService
  ) {
    this.themeService.initTheme();
  }

  ngOnInit(): void {
    // Safety net: force-release any stuck invisible spinner overlay on app startup
    setTimeout(() => {
      forceResetLoader(this.spinner);
    }, 500);
  }
}
